/*
src/ui-misc/ColorPicker.js
wgbh-skydiagram-testing
astro.unl.edu
2019-06-14
*/


import * as React from 'react';

import {Button, Popover} from '@blueprintjs/core';

import {ChromePicker} from 'react-color';


/*

props (required):
	label				- display name
	allowAlpha	- boolean
	color				- a string of EXACTLY the form "#<hex value>" or "rgba(<r value>, <g value>, <b value>, <a value>)",
								where the r, g, and b values are integers in [0, 255], and a is a float in [0, 1]
	onChange		- function(color), where color is the new color string

*/


export class ColorPicker extends React.Component {


	constructor(props) {
		super(props);

		this.onColorChange = this.onColorChange.bind(this);
	}


	onColorChange(arg) {

		let colorStr;
		if (this.props.allowAlpha) {
			colorStr = 'rgba(' + arg.rgb.r + ', ' + arg.rgb.g + ', ' + arg.rgb.b + ', ' + arg.rgb.a.toPrecision(4) + ')'; 
		} else {
			colorStr = arg.hex;
		}

		this.props.onChange(colorStr);
	}


	render() {

		let color = this.props.color;
		if (color.startsWith('rgba(')) {
			let inner = color.slice(5, -1);
			let comps = inner.split(',');
			if (comps.length === 4) {
				let obj = {};
				obj.r = parseInt(comps[0]);
				obj.g = parseInt(comps[1]);
				obj.b = parseInt(comps[2]);
				obj.a = parseFloat(comps[3]);
				if (Number.isNaN(obj.r) || Number.isNaN(obj.g) || Number.isNaN(obj.b) || Number.isNaN(obj.a)) {
					console.error('An rgba parsed color component is NaN.');
				} else if (obj.r < 0 || obj.r > 255 || obj.g < 0 || obj.g > 255 || obj.b < 0 || obj.b > 255 || obj.a < 0 || obj.a > 1) {
					console.error('An rgba parsed color component is out of range.');
				} else {
					color = obj;
				}
			} else {
				console.error('An rgba color does not have the correct number of components');
			}
		}

		return (
			<div style={{margin: "25px 0"}}>
				<Popover>
					<Button style={{padding: "8px"}}>
						<div style={{width: "48px", height: "18px", backgroundColor: this.props.color}}></div>
					</Button>
					<ChromePicker onChange={this.onColorChange} color={color} disableAlpha={!this.props.allowAlpha} />
				</Popover>
				<span style={{margin: "0 17px"}}>{this.props.label}</span>
			</div>
		);

	}

}


